import React, { useState, useEffect } from "react";
import "./productquantity.css";
import { batch, useDispatch } from "react-redux";
import { getUserCart, updateUserCart } from "../../appState/slices/cart/cartSlice";

const ProductQuantity = ({ quantity, purity, quality, productid, color, ringsize, diamondtype }) => {
  const [count, setCount] = useState(quantity);
  const dispatch = useDispatch();
  const incrementCount = async () => {
    try {
      setCount(count + 1);
      await batch(async () => {
        await dispatch(
          updateUserCart({
            product: productid,
            quantity: 1,
            purity: purity,
            quality: quality,
            color: color,
            operation: "add",
            ringsize: ringsize,
            diamondtype : diamondtype,
          })
        );
        await dispatch(getUserCart());
      })
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const decrementCount = async () => {
    try {
      if (count !== 1) {
        setCount(count - 1);
        await batch(async () => {
          await dispatch(
            updateUserCart({
              product: productid,
              quantity: 1,
              purity: purity,
              quality: quality,
              color: color,
              operation: "subtract",
              ringsize: ringsize,
              diamondtype : diamondtype
            })
          );
          await dispatch(getUserCart());
        })
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  return (
    <div className="productqunatitycontainer">
      <button className="incrdecbtns" onClick={decrementCount}>
        -
      </button>
      <div className="productqunatity-counter">{quantity}</div>
      <button className="incrdecbtns" onClick={incrementCount}>
        +
      </button>
    </div>
  );
};

export default ProductQuantity;
